import { AwsUtil } from './../../authentication/aws.service';
import {
    PIE_COLOR_STRIP_1,
    PIE_COLOR_STRIP_2,
    PIE_COLOR_STRIP_3,
    PIE_COLOR_STRIP_4,
    PIE_COLOR_STRIP_5,
    PIE_COLOR_STRIP_6
} from './../../common/color-util';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
    GetTransactionDetailsResult,
    GetTransactionDetailsRequest,
} from '@liquitics/transaction';
import {
    numberToString
} from '@liquitics/transaction';
import { createSimplePieChart } from '../../common/chart/graphical-chart-generator';

@Component({
    selector: 'app-transaction-detail',
    templateUrl: './transaction-detail.component.html',
    styleUrls: ['./transaction-detail.component.scss']
})
export class TransactionDetailComponent implements OnInit {
    todaysCountChart: any;
    todaysSumChart: any;
    recentCountChart: any;
    recentSumChart: any;
    topCountChart: any;
    topSumChart: any;
    transactionDetailResult: GetTransactionDetailsResult;

    loading: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private amChartsService: AmChartsService,
        private awsUtil: AwsUtil
    ) {
        this.loading = true;
        const transactionDetailsResultPromise: Promise<GetTransactionDetailsResult> = data.transactionDetailsResultPromise;
        transactionDetailsResultPromise
            .then((transactionDetailsResult: GetTransactionDetailsResult) => {
                this.updateCountCharts(transactionDetailsResult, data.request);
                this.transactionDetailResult = transactionDetailsResult;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            })
            ;
    }

    ngOnInit() {
        this.todaysCountChart = createSimplePieChart(this.amChartsService, 'todayscountchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_1)
        this.todaysSumChart = createSimplePieChart(this.amChartsService, 'todayssumchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_2)
        this.recentCountChart = createSimplePieChart(this.amChartsService, 'recentcountchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_3)
        this.recentSumChart = createSimplePieChart(this.amChartsService, 'recentsumchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_4)
        this.topCountChart = createSimplePieChart(this.amChartsService, 'topcountchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_5)
        this.topSumChart = createSimplePieChart(this.amChartsService, 'topsumchartdiv', 'boundary', 'stat', PIE_COLOR_STRIP_6)
    }

    convertToAbs(stats: number[]): number[] {
        return stats
            .map((n: number) => {
                return Math.abs(n);
            })
    }

    updateCountCharts(transactionDetailsResult: GetTransactionDetailsResult, request: GetTransactionDetailsRequest) {
        const entrySets = [
            transactionDetailsResult.todayCountStats,
            this.convertToAbs(transactionDetailsResult.todaySumStats),
            transactionDetailsResult.recentCountStats,
            this.convertToAbs(transactionDetailsResult.recentSumStats),
            transactionDetailsResult.topCountStats,
            this.convertToAbs(transactionDetailsResult.topSumStats),
        ]
            .map((countStats: number[]) => {
                return request.countAmountThresholds
                    .map((boundary: number, boundaryIndex: number, boundaryArr: number[]) => {
                        let boundaryStr = numberToString(boundary, '0a');
                        if (boundaryIndex < boundaryArr.length - 1) {
                            boundaryStr += ` to ${numberToString(boundaryArr[boundaryIndex + 1], '0a')}`;
                        } else {
                            boundaryStr += '+';
                        }
                        return {
                            boundary: boundaryStr,
                            stat: countStats[boundaryIndex]
                        };
                    });
            });

        this.todaysCountChart.dataProvider = entrySets[0];
        this.todaysCountChart.validateData();
        this.todaysCountChart.invalidateSize();
        this.todaysSumChart.dataProvider = entrySets[1];
        this.todaysSumChart.validateData();
        this.todaysSumChart.invalidateSize();
        this.recentCountChart.dataProvider = entrySets[2];
        this.recentCountChart.validateData();
        this.recentCountChart.invalidateSize();
        this.recentSumChart.dataProvider = entrySets[3];
        this.recentSumChart.validateData();
        this.recentSumChart.invalidateSize();
        this.topCountChart.dataProvider = entrySets[4];
        this.topCountChart.validateData();
        this.topCountChart.invalidateSize();
        this.topSumChart.dataProvider = entrySets[5];
        this.topSumChart.validateData();
        this.topSumChart.invalidateSize();
    }
}
